export default function WatermarkScreen() {
  return (
    <>
      <div className="watermarkBackground"></div>
      <div className="watermarkBackground watermarkBackground2"></div>
    </>
  );
}
